import { post } from "../api_helper";
import * as url from "../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const getAuditLogs = (payload, location) => post(`${baseURL + url.ADVANCE_COMMON_SEARCH}/${location || "commonSearch"}`, payload);

export const getAuditLogDiff = (payload) => post(`${baseURL + url.ADVANCE_COMMON_SEARCH}${url.AUDIT_LOG_DIFF}`, payload);